import { createStore } from 'framework7';
import { http } from '../api/config.js';

const carLoanIssue = createStore({
  state: {
    item: {},
    list: [],
  },
  actions: {
//Mutations
    set_item({ state }, item) {
      state.item = item;
    },
//End mutations

    async getSingleIssue({ dispatch }, loanId) {
      let response = [];
      let result = {};

      result = await http.get(`loan/issue/single/${loanId}`);
      if (result.status === 200) {
        response = result.data;
        return response;
      }
      else {
        return result;
      }
    },

    async getIssueByLoan({ dispatch }, loanId) {
      let response = [];
      let result = {};

      result = await http.get(`loan/issue/data/${loanId}`);
      if (result.status === 200) {
        response = result.data;
        return response;
      }
      else {
        return result;
      }
    },

    async createLoanIssue({ dispatch }, data) {
      let response = [];
      let result = {};

      result = await http.post(`loan/issue/create`, data, { headers: {'content-type': 'application/x-www-form-urlencoded'} });
      if (result.status === 201) {
        response = result.data;
        return response;
      }
      else {
        return result;
      }
    },

    async getIssuePenaltyListLocalized({ dispatch }, { loanIssueId, languageCode }) {
      let response = [];
      let result = {};

      result = await http.get(`loan/issue/list/localized/${loanIssueId}/${languageCode}`);
      if (result.status === 200) {
        response = result.data;
        return response;
      }
      else {
        return result;
      }
    },

    async getCurrentLoanedIssues({ dispatch}) {
      let response = [];
      let result = {};

      result = await http.get(`loaned/issues/list`);
      if (result.status === 200) {
        response = result.data;
        return response;
      }
      else {
        return result;
      }
    },

    async saveIssueDetail({dispatch}, data){
      let response = [];
      let result = {};

      result = await http.post(`loan/issue/detail/save`, data, { headers: {'content-type': 'application/x-www-form-urlencoded'} });
      if (result.status === 200) {
        response = result.data;
        return response;
      }
      else {
        return result;
      }
    },

    async scaleLoanIssue({ dispatch }, data){
      let response = [];
      let result = {};

      result = await http.post(`loan/issue/scale`, data, { headers: {'content-type': 'application/x-www-form-urlencoded'} });
      if (result.status === 200) {
        response = result.data;
        return response;
      }
      else {
        return result;
      }
    },

    async closeLoanIssue({ dispatch }, data){
      let response = [];
      let result = {};

      result = await http.post(`loan/issue/close`, data, { headers: {'content-type': 'application/x-www-form-urlencoded'} });
      if (result.status === 200) {
        response = result.data;
        return response;
      }
      else {
        return result;
      }
    },

    async cancelLoanIssue({ dispatch }, data){
      let response = [];
      let result = {};

      result = await http.post(`loan/issue/cancel`, data, { headers: {'content-type': 'application/x-www-form-urlencoded'} });
      if (result.status === 200) {
        response = result.data;
        return response;
      }
      else {
        return result;
      }
    },
  },

  getters: {
    Item({ state }) {
      return state.item;
    }
  },
});

export default carLoanIssue;
